import { render, staticRenderFns } from "./SelectSFServices.vue?vue&type=template&id=3579ffc8&scoped=true&"
import script from "./SelectSFServices.vue?vue&type=script&lang=js&"
export * from "./SelectSFServices.vue?vue&type=script&lang=js&"
import style0 from "./SelectSFServices.vue?vue&type=style&index=0&id=3579ffc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3579ffc8",
  null
  
)

export default component.exports